import React from 'react';

export default function Footer(params) {
  return(
    <footer className='w-full mt-24 bg-primary p-8 text-white'>
      <div className='lg:w-4/6 md:w-5/6 w-11/12 m-auto'> 
        <p className='font-semibold'>RST 324 - Av. dos Emancipacionistas, 222 - Cx. Postal 25 - CEP: 99.260-000, Distrito Industrial, Casca/RS</p>
      </div>
    </footer>
  )
};
